exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hidden {\n    display: none;\n}\n.active {\n    display: block;\n}\n", ""]);

// exports
